import { graphql } from '@apollo/client/react/hoc';
import { flowRight as compose } from 'lodash';
import { EditNameForm } from './EditNameForm';
import SET_USER_NAME_CHANGE_BAN from './setUserNameChangeBan.gql';
import UNSET_USER_NAME_CHANGE_BAN from './unsetUserNameChangeBan.gql';
import UPDATE_USER_BY_ID from './updateUserByID.gql';

const withMutationUpdateUserByID = graphql(UPDATE_USER_BY_ID, {
  props: ({ ownProps, mutate }) => ({
    ...ownProps,
    updateUserByID: mutate,
  }),
});

const withMutationSetUserNameChangeBan = graphql(SET_USER_NAME_CHANGE_BAN, {
  props: ({ ownProps, mutate }) => ({
    ...ownProps,
    setUserNameChangeBan: mutate,
  }),
});

const withMutationUnsetUserNameChangeBan = graphql(UNSET_USER_NAME_CHANGE_BAN, {
  props: ({ ownProps, mutate }) => ({
    ...ownProps,
    unsetUserNameChangeBan: mutate,
  }),
});

const EditNameFormCompose = compose(
  withMutationUpdateUserByID,
  withMutationSetUserNameChangeBan,
  withMutationUnsetUserNameChangeBan
)(EditNameForm) as typeof EditNameForm;

export default EditNameFormCompose;
